import React, { useState, useEffect } from 'react';
import axios from 'axios';
import moment from 'moment';

const API = process.env.REACT_APP_APP_API_URL;

// The seller's ViBirr feed, embedded on their shop page.
export default function VibirrPosts({ wallet, businessName }) {
    const [posts, setPosts] = useState(null);

    useEffect(() => {
        if (!wallet) { setPosts([]); return; }
        axios.get(`${API}/api/vibirr/posts/${wallet}`)
            .then(r => setPosts((r.data.status && r.data.posts) || []))
            .catch(() => setPosts([]));
    }, [wallet]);

    if (!wallet || (posts && posts.length === 0)) {
        return (
            <div className="bp-panel bp-tab-empty">
                <span className="bp-empty-glyph" aria-hidden="true">📡</span>
                <h3>Nothing on ViBirr yet</h3>
                <p className="bp-dim">
                    {businessName || 'This shop'} hasn't posted on ViBirr — the Birr ecosystem's social network.
                </p>
                <a className="bp-btn-ghost" href="https://vibirr.com" target="_blank" rel="noreferrer" style={{ marginTop: 14 }}>
                    Explore ViBirr ↗
                </a>
            </div>
        );
    }

    if (!posts) {
        return <div className="bp-panel bp-tab-empty"><p className="bp-dim">Loading ViBirr posts…</p></div>;
    }

    return (
        <div className="bp-panel" style={{ padding: '26px' }}>
            <div className="bp-vb-head">
                <span className="bp-chat-vb">ViBirr</span>
                <span className="bp-dim">{posts.length} post{posts.length === 1 ? '' : 's'} · live from the social feed</span>
                <a href="https://vibirr.com" target="_blank" rel="noreferrer" className="bp-join-selllink">Open ViBirr →</a>
            </div>
            <div className="bp-vb-grid">
                {posts.map((p, i) => (
                    <article className="bp-vb-post" key={p.id || i}>
                        {(p.videoUri || p.imageUri) && (
                            <div className="bp-vb-media">
                                {p.videoUri
                                    ? <video src={p.videoUri} muted loop playsInline onMouseOver={e => e.target.play()} onMouseOut={e => e.target.pause()} />
                                    : <img alt="" src={p.imageUri} loading="lazy" />}
                            </div>
                        )}
                        {p.content && <p className="bp-vb-text">{p.content}</p>}
                        <div className="bp-vb-meta">
                            <span>❤️ {(p.likes || []).length}</span>
                            <span>💬 {(p.comments || []).length}</span>
                            {p.timestamp && <span className="bp-dim">{moment(p.timestamp).fromNow()}</span>}
                        </div>
                    </article>
                ))}
            </div>
        </div>
    );
}
